// Generated from java-escape by ANTLR 4.11.1
// jshint ignore: start
import antlr4 from 'antlr4';

// This class defines a complete listener for a parse tree produced by QueryExprParser.
export default class QueryExprListener extends antlr4.tree.ParseTreeListener {

	// Enter a parse tree produced by QueryExprParser#rootExpression.
	enterRootExpression(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#rootExpression.
	exitRootExpression(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#MapExpr.
	enterMapExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#MapExpr.
	exitMapExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#AndExpr.
	enterAndExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#AndExpr.
	exitAndExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#EqualExpr.
	enterEqualExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#EqualExpr.
	exitEqualExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#MultiplyExpr.
	enterMultiplyExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#MultiplyExpr.
	exitMultiplyExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#UnaryNotExpr.
	enterUnaryNotExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#UnaryNotExpr.
	exitUnaryNotExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#RaiseToExpr.
	enterRaiseToExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#RaiseToExpr.
	exitRaiseToExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#IndexExpr.
	enterIndexExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#IndexExpr.
	exitIndexExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#DivideExpr.
	enterDivideExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#DivideExpr.
	exitDivideExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#MemberExpr.
	enterMemberExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#MemberExpr.
	exitMemberExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#IdentifierExpr.
	enterIdentifierExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#IdentifierExpr.
	exitIdentifierExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#LiteralExpr.
	enterLiteralExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#LiteralExpr.
	exitLiteralExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#ListExpr.
	enterListExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#ListExpr.
	exitListExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#InExpr.
	enterInExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#InExpr.
	exitInExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#LessThanExpr.
	enterLessThanExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#LessThanExpr.
	exitLessThanExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#GreaterThanExpr.
	enterGreaterThanExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#GreaterThanExpr.
	exitGreaterThanExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#AddExpr.
	enterAddExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#AddExpr.
	exitAddExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#NotEqualExpr.
	enterNotEqualExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#NotEqualExpr.
	exitNotEqualExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#OrExpr.
	enterOrExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#OrExpr.
	exitOrExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#WithoutExpr.
	enterWithoutExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#WithoutExpr.
	exitWithoutExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#LessThanOrEqualExpr.
	enterLessThanOrEqualExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#LessThanOrEqualExpr.
	exitLessThanOrEqualExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#ConcatExpr.
	enterConcatExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#ConcatExpr.
	exitConcatExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#FunctionCallExpr.
	enterFunctionCallExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#FunctionCallExpr.
	exitFunctionCallExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#UnaryPlusExpr.
	enterUnaryPlusExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#UnaryPlusExpr.
	exitUnaryPlusExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#ParenthesizedExpr.
	enterParenthesizedExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#ParenthesizedExpr.
	exitParenthesizedExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#SubtractExpr.
	enterSubtractExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#SubtractExpr.
	exitSubtractExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#WithExpr.
	enterWithExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#WithExpr.
	exitWithExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#ModExpr.
	enterModExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#ModExpr.
	exitModExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#UnaryMinusExpr.
	enterUnaryMinusExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#UnaryMinusExpr.
	exitUnaryMinusExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#GreaterThanOrEqualExpr.
	enterGreaterThanOrEqualExpr(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#GreaterThanOrEqualExpr.
	exitGreaterThanOrEqualExpr(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#NullLiteral.
	enterNullLiteral(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#NullLiteral.
	exitNullLiteral(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#TrueLiteral.
	enterTrueLiteral(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#TrueLiteral.
	exitTrueLiteral(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#FalseLiteral.
	enterFalseLiteral(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#FalseLiteral.
	exitFalseLiteral(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#DateLiteral.
	enterDateLiteral(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#DateLiteral.
	exitDateLiteral(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#TimeLiteral.
	enterTimeLiteral(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#TimeLiteral.
	exitTimeLiteral(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#DateTimeLiteral.
	enterDateTimeLiteral(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#DateTimeLiteral.
	exitDateTimeLiteral(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#StringLiteral.
	enterStringLiteral(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#StringLiteral.
	exitStringLiteral(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#NumberLiteral.
	enterNumberLiteral(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#NumberLiteral.
	exitNumberLiteral(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#IntegerLiteral.
	enterIntegerLiteral(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#IntegerLiteral.
	exitIntegerLiteral(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#list.
	enterList(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#list.
	exitList(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#map.
	enterMap(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#map.
	exitMap(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#keyValues.
	enterKeyValues(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#keyValues.
	exitKeyValues(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#keyValue.
	enterKeyValue(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#keyValue.
	exitKeyValue(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#key.
	enterKey(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#key.
	exitKey(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#functionCall.
	enterFunctionCall(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#functionCall.
	exitFunctionCall(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#callArgs.
	enterCallArgs(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#callArgs.
	exitCallArgs(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#values.
	enterValues(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#values.
	exitValues(ctx) {
	}


	// Enter a parse tree produced by QueryExprParser#identifier.
	enterIdentifier(ctx) {
	}

	// Exit a parse tree produced by QueryExprParser#identifier.
	exitIdentifier(ctx) {
	}



}